var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "1 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6983 3.8522L16.0576 16.3053C15.8583 17.1841 15.3389 17.4028 14.6008 16.9891L10.577 14.0241L8.63577 15.8916C8.42077 16.1066 8.2414 16.286 7.82702 16.286L8.1164 12.1885L15.5733 5.45033C15.8976 5.16158 15.5026 5.00095 15.0695 5.29033L5.85077 11.0953L1.88202 9.85283C1.0189 9.58345 1.00327 8.9897 2.06202 8.57533L17.5851 2.5947C18.3039 2.32533 18.9326 2.7547 18.6983 3.85283V3.8522Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a99b2ece0d72ccc7e25f388730cbfc17.svg";
export { ForwardRef as ReactComponent };